define([
	"dojo/_base/lang",
	"csi/action/Excel",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginMenu"
], function(lang,Excel,PluginFactory,ToolbarPluginMenu) {

	return PluginFactory.declare("tableExcelFlat", ToolbarPluginMenu, {
		constructor: function() {
			this.defAction = lang.mixin(new Excel(), {
				m_id: "TableExcelFlat",
				m_bFlat: true
			});
			this.defAction.resolve();
		},

		canShowPlugin: function() {
			// summary: enable if view is hierarchical or there are matrices
			var view = this.getView();
			
			// enforce we have a hierarchy or a matrix
			const matrixCount = view.defView.getHeadings().filter((h) => h.isMatrixGroup).length;
			return view.bHierarchy || !!matrixCount;
		}
	});
});
